module.exports = __webpack_public_path__ + "static/media/Rim.9f4b36aa.wav";